import { Sparkle } from "@/components/Icons";

const ITEMS = ["Sites web", "Applications", "Web apps", "Expériences digitales", "Design system", "Motion"];

const Row = ({ hidden }) => (
  <div className="flex items-center shrink-0" aria-hidden={hidden}>
    {ITEMS.map((item, i) => (
      <div key={i} className="flex items-center shrink-0">
        <span className="font-display font-extrabold uppercase text-3xl md:text-5xl lg:text-6xl text-flytab-green px-6 md:px-10 whitespace-nowrap tracking-tight">
          {item}
        </span>
        <Sparkle className="w-6 md:w-9 shrink-0" stroke="none" strokeWidth={0} />
      </div>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      className="bg-flytab-black py-8 md:py-12 overflow-hidden border-b border-flytab-line"
      data-testid="marquee-section"
    >
      <div className="flex w-max animate-marquee">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </section>
  );
}
